// extracted by mini-css-extract-plugin
export default {"headerContainer":"EKoUBlVVA44dujJTtuXD","takeawayContainer":"plg9SmUhmvw858TpM3RT","articleBody":"SE2jANfgnguT1IMXb9i2","isFeature":"b3DNjCk6zlBdDx2bbpep"};